import React, { useEffect, useState } from 'react';
import { Table, Container, Button, Modal, Form, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosConfig';

const AdminCategories = () => {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');
  const [show, setShow] = useState(false);
  const [currentCategory, setCurrentCategory] = useState({
    name: '',
    bannerImage: ''
  });

  const navigate = useNavigate();

  const fetchCategories = async () => {
    document.title = '分類管理';
    try {
      const response = await axiosInstance.get('/categories');
      setCategories(response.data);
    } catch (error) {
      setError('無法獲取分類，請稍後再試。');
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleShow = (category) => {
    setCurrentCategory(category || {
      name: '',
      bannerImage: ''
    });
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('token');
      if (currentCategory._id) {
        // 更新分類
        await axiosInstance.put(`/categories/${currentCategory.categoryId}`, currentCategory, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      } else {
        // 添加新分類
        await axiosInstance.post('/categories', currentCategory, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      }
      fetchCategories();
      handleClose();
    } catch (error) {
      setError('無法保存分類，請稍後再試。');
    }
  };

  const handleDelete = async (categoryId) => {
    try {
      const token = localStorage.getItem('token');
      await axiosInstance.delete(`/categories/${categoryId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      fetchCategories();
    } catch (error) {
      setError('無法刪除分類，請稍後再試。');
    }
  };

  const handleViewOrders = (categoryId) => {
    navigate(`/admin/category-orders/${categoryId}`);
  };

  return (
    <Container>
      <h1>分類管理</h1>
      {error && <Alert variant="danger">{error}</Alert>}
      <Button variant="primary" onClick={() => handleShow()}>添加分類</Button>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>編號</th>
            <th>名稱</th>
            <th>Banner圖片</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category) => (
            <tr key={category._id}>
              <td>{category.categoryId}</td>
              <td>{category.name}</td>
              <td><img src={category.bannerImage} alt={category.name} style={{ width: '100px' }} /></td>
              <td>
                <Button variant="secondary" onClick={() => handleShow(category)}>編輯</Button>{' '}
                <Button variant="danger" onClick={() => handleDelete(category.categoryId)}>刪除</Button>{' '}
                <Button variant="info" onClick={() => handleViewOrders(category.categoryId)}>查看訂單統計</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{currentCategory._id ? '編輯分類' : '添加分類'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="categoryName">
              <Form.Label>名稱</Form.Label>
              <Form.Control
                type="text"
                value={currentCategory.name}
                onChange={(e) => setCurrentCategory({ ...currentCategory, name: e.target.value })}
              />
            </Form.Group>
            <Form.Group controlId="bannerImage">
              <Form.Label>Banner圖片</Form.Label>
              <Form.Control
                type="text"
                value={currentCategory.bannerImage}
                onChange={(e) => setCurrentCategory({ ...currentCategory, bannerImage: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>取消</Button>
          <Button variant="primary" onClick={handleSave}>保存</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AdminCategories;
